<app-new-carpark-list
  *ngIf="this.accountService.operatorStatus === 'carpark_added'"
></app-new-carpark-list>

<app-first-time-dash
  class="dashboard-wrapper"
  *ngIf="this.accountService.operatorStatus !== 'carpark_added'"
>
</app-first-time-dash>
